import { type PropsWithChildren } from 'react';

import { textStyle as textStyleCSS } from '../../styles/textStyle.sty.js';

/**
 * The footer inside the Terminology Overlay. Add links to further related documentation.
 * @public
 */
export const Footer = ({ children }: PropsWithChildren) => (
  <footer className={textStyleCSS({ textStyle: 'base' })}>{children}</footer>
);

Footer.displayName = 'TerminologyOverlay.Footer';
